import PageWrapper from "../../components/ui/wrappers/PageWrapper";
import Seo from "../../components/Seo";
import InvestHero from "./components/InvestHero";
import KeyFigures from "./components/KeyFigures";
import ConcreteExample from "./components/ConcreteExample";
import RiskRating from "./components/RiskRating";
import InvestorJourney from "./components/InvestorJourney";
import InvestmentSimulator from "./components/InvestmentSimulator";
import FinalCta from "./components/FinalCta";

const Investir = () => {
    return (
        <PageWrapper>
            <Seo
                title="Investir"
                description="Investissez dans des PME françaises solides avec PretUp : parcours investisseur encadré, notation de chaque projet, sûretés adossées aux prêts et zéro frais."
            />
            <main>
                <InvestHero />
                <KeyFigures />
                <ConcreteExample />
                <RiskRating />
                <InvestorJourney />
                <InvestmentSimulator />
                <FinalCta />
            </main>
        </PageWrapper>
    );
};

export default Investir;
